/* LILINMOMO section-storybook-collage.js — Chat 04 §9.2
   Tile scroll-reveal via IntersectionObserver (lifted from 03-homepage-prototype.html).
   Hover/focus caption reveal + tile lift stay pure CSS — no JS.
   When reveal is off or prefers-reduced-motion is set, tiles render visible immediately.
   mount/unmount honor Dawn's shopify:section:load / :unload re-render contract. */

(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function revealAll(cats) {
    cats.forEach(function (c) { c.classList.add('is-visible'); });
  }

  function mount(root) {
    var stage = root.querySelector('.collage-stage');
    if (!stage) return;

    var cats = Array.prototype.slice.call(stage.querySelectorAll('.cat'));
    if (!cats.length) return;

    var reveal = stage.dataset.scrollReveal === 'true';
    if (!reveal || REDUCED.matches || !('IntersectionObserver' in window)) {
      revealAll(cats);
      return;
    }

    // Reveal path only: opt the stage into the hidden-then-animate-in CSS state.
    // (Tiles are opacity:1 by default; this class is what gates them hidden.)
    stage.classList.add('collage-is-ready');

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var idx = cats.indexOf(entry.target);
          entry.target.style.transitionDelay = (idx * 80) + 'ms';
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    cats.forEach(function (c) { io.observe(c); });
    stage._lmIO = io;
  }

  function unmount(root) {
    var stage = root.querySelector('.collage-stage');
    if (stage && stage._lmIO) {
      stage._lmIO.disconnect();
      stage._lmIO = null;
    }
  }

  // First paint
  document.querySelectorAll('.section-collage').forEach(mount);

  // Theme editor re-render contract
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.classList.contains('section-collage')) mount(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.classList.contains('section-collage')) unmount(e.target);
  });
})();
